/**
 * AGROMX Frontend - Modal Utility
 * Sistema de modales
 */

class Modal {
  constructor() {
    this.container = document.getElementById('modal-container');
    this.currentModal = null;
  }

  /**
   * Abrir modal
   * @param {string} title
   * @param {string|Node} content
   * @param {Array} buttons - [{ text, class, onClick, closeOnClick }]
   * @param {Object} [options] - { dismissable?: boolean } — default true. Si false, desactiva click-fuera y botón X.
   *                            { ancho?: string } — ancho máximo (ej. '1200px'); por omisión el del CSS (800px).
   */
  open(title, content, buttons = [], options = {}) {
    // Cerrar modal anterior si existe
    this.close();

    const dismissable = options.dismissable !== false;

    // Crear overlay (.modal según CSS)
    const overlay = document.createElement('div');
    overlay.className = 'modal';
    if (dismissable) {
      overlay.onclick = (e) => {
        if (e.target === overlay) this.close();
      };
    }

    // Crear contenedor interno (.modal-content según CSS)
    const modalContent = document.createElement('div');
    modalContent.className = 'modal-content';
    // B5c: los detalles con tablas anchas (costo por unidad) piden más que los 800px del CSS
    if (options.ancho) {
      modalContent.style.maxWidth = options.ancho;
      modalContent.style.width = '95%';
    }

    // Header (la X solo aparece si es dismissable)
    const header = document.createElement('div');
    header.className = 'modal-header';
    header.innerHTML = `
      <h3 class="modal-title">${title}</h3>
      ${dismissable ? '<button class="modal-close" onclick="window.modal.close()">×</button>' : ''}
    `;

    // Body
    const body = document.createElement('div');
    body.className = 'modal-body';
    if (typeof content === 'string') {
      body.innerHTML = content;
    } else {
      body.appendChild(content);
    }

    // Footer
    const footer = document.createElement('div');
    footer.className = 'modal-footer';

    buttons.forEach(btn => {
      const button = document.createElement('button');
      button.className = `btn ${btn.class || 'btn-secondary'}`;
      button.textContent = btn.text;
      if (btn.disabled) button.disabled = true;
      if (btn.title) button.title = btn.title;
      button.onclick = () => {
        if (btn.disabled) return;
        if (btn.onClick) btn.onClick();
        if (btn.closeOnClick !== false) this.close();
      };
      footer.appendChild(button);
    });

    // Ensamblar modal
    modalContent.appendChild(header);
    modalContent.appendChild(body);
    if (buttons.length > 0) {
      modalContent.appendChild(footer);
    }
    overlay.appendChild(modalContent);

    this.container.appendChild(overlay);
    this.currentModal = overlay;

    // Prevenir scroll del body
    document.body.style.overflow = 'hidden';
  }

  /**
   * Cerrar modal
   */
  close() {
    if (this.currentModal) {
      this.currentModal.remove();
      this.currentModal = null;
      document.body.style.overflow = '';
    }
  }

  /**
   * Modal de confirmación
   */
  confirm(title, message, onConfirm) {
    this.open(
      title,
      `<p>${message}</p>`,
      [
        {
          text: 'Cancelar',
          class: 'btn-secondary'
        },
        {
          text: 'Confirmar',
          class: 'btn-primary',
          onClick: onConfirm
        }
      ]
    );
  }

  /**
   * Modal de alerta
   */
  alert(title, message) {
    this.open(
      title,
      `<p>${message}</p>`,
      [
        {
          text: 'Aceptar',
          class: 'btn-primary'
        }
      ]
    );
  }

  /**
   * Modal de formulario
   */
  form(title, formHtml, onSubmit) {
    const form = document.createElement('form');
    form.innerHTML = formHtml;
    form.onsubmit = (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const data = Object.fromEntries(formData);
      onSubmit(data);
    };

    this.open(
      title,
      form,
      [
        {
          text: 'Cancelar',
          class: 'btn-secondary'
        },
        {
          text: 'Guardar',
          class: 'btn-primary',
          onClick: () => form.requestSubmit(),
          closeOnClick: false
        }
      ]
    );
  }
}

export default new Modal();
